module.exports = __webpack_public_path__ + "img/qingfengAppImage.f509b8a1.png";